import { avatarAssetsApi } from './avatar-assets.api';
import { baseApi } from './base.api';

export const streamojiApi = {
    ...baseApi,
    avatarAssets: { ...avatarAssetsApi },
};
